import config from '../../config'

const getIsConditionInInspectionTypeBuildersRequest = (params = {}) => {
  const { airportId, id } = params

  return {
    method: 'get',
    url: `${config.baseUrl}/${airportId}/InspectionTypeBuilders/ConditionExists/${id}`,
  }
}

export default getIsConditionInInspectionTypeBuildersRequest
